const notificationActionPaths: Record<string, string> = {
  "enterprise::organization::access": "/organizacao",
  "enterprise::payments::access": "/organizacao/pagamentos",
  "ads::hall::access": "/anuncios/atrio",
  "ads::radio::access": "/anuncios/radio",
  "ads::tv::access": "/anuncios/tv",
  "negotiate::hall::access": "/negociar",
};

export function notificationActionPath(action: string): string | undefined {
  return notificationActionPaths[action];
}
